<app-billing-list [allowAdd]="true"></app-billing-list>